import React from 'react'
import { connect } from 'react-redux';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import $ from 'jquery'

import CreateEditUser from './CreateEditUser'

import { clearNoDataError } from '../../GlobalStateContainer/actions'

import {
    fetchUser,
    fetchUserError,
    createUser,
    updateUser,
    errorUser,
    fetchUsersList,
    fetchUserHistory,
    errorUserHistory,
    fetchUserUsers,
    errorUserUsers
} from './actions'

import CommError from '../../Shared/Errors/Errors'
import ConfirmModal from '../../Shared/ConfirmModal/ConfirmModal'
import FilterList from '../../Shared/FilterList/FilterList'

import './Users.css'

var Spinner = require('react-spinkit');

let chkReturn = 0;
let userState = true;

const HIST_PAGE_SZE = 25

class Users extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            user: {
                details: {},
                detailsDirty: false,

                seo: {},
                seoDirty: false,

                role: {},
                roleDirty: false
            },
            confirm: false,
            newPanel: '',
            currentPanel: 'Details',
            search: '',
            historyPage: 1,
            historyDate: '',
            historyUser: '',
            editUserMode: false,
            activeStatusFilters: ['Active']
        };

        this.fetchUserErrorClear = this.fetchUserErrorClear.bind(this);
        this.errorUserClear = this.errorUserClear.bind(this);
        this.errorNoDataClear = this.errorNoDataClear.bind(this);

        this.userView = this.userView.bind(this);

        this.changeState = this.changeState.bind(this);
        this.changeStateVerify = this.changeStateVerify.bind(this);

        this.userEdit = this.userEdit.bind(this);
        this.userEditVerify = this.userEditVerify.bind(this);

        this.updateUser = this.updateUser.bind(this);

        this.cancelUser = this.cancelUser.bind(this);
        this.closeUser = this.closeUser.bind(this);

        this.afterOpen = this.afterOpen.bind(this);

        this.selectPanel = this.selectPanel.bind(this);
        this.switchPanel = this.switchPanel.bind(this);

        this.search = this.search.bind(this);

        this.newDateSearch = this.newDateSearch.bind(this);
        this.newUserSearch = this.newUserSearch.bind(this);

        this.loadMore = this.loadMore.bind(this);

        this.processStatusFilter = this.processStatusFilter.bind(this);

        this.pageDescriptionChange = this.pageDescriptionChange.bind(this);
        this.pageDescriptionUpdate = this.pageDescriptionUpdate.bind(this);

        this.detailsUpdate = this.detailsUpdate.bind(this);
        this.seoUpdate = this.seoUpdate.bind(this);
        this.roleUpdate = this.roleUpdate.bind(this);

        this.confirmNo = this.confirmNo.bind(this);
        this.confirmYes = this.confirmYes.bind(this);
    }

    selectPanel(e) {
        let newPanel = e.currentTarget.attributes["panel"].value

        if (newPanel == 'History' && this.state.viewUser)
            $('button.user').css('display', 'none')
        else 
            $('button.user').css('display', 'inline-block')

        if (this.state.currentPanel != newPanel) {

            this.setState({ newPanel: newPanel })

            switch (this.state.currentPanel) {
                case 'Details':
                    if (this.state.user.detailsDirty) 
                        this.setState({ confirm: true })
                    else
                        this.switchPanel(newPanel)
                    break

                case 'Seo':
                    if (this.state.user.seoDirty) 
                        this.setState({ confirm: true })
                    else
                        this.switchPanel(newPanel)
                    break

                default:
                    this.switchPanel(newPanel)
            }
        }
    }

    switchPanel(panel) {
        $('div.panelFrame').css('display', 'none')

        $('li.userview').removeClass("selected")
        $('li[panel='+panel+']').addClass('selected')

        $('div#' + panel).css('display', 'block')

        this.setState({ currentPanel: panel })
    }

    search() {
        this.setState({ search: $('#search').val()})
    }

    newDateSearch(e) {
        if (chkReturn) return;
        chkReturn = 1;

        let histDate = $('#history-date').val()

        if (histDate != this.state.historyDate) {
            this.setState(
                {
                    historyPage: 1,
                    historyDate: histDate
                })

            let userInfo = histDate ?
                    { userId: this.props.user.user.id, fromDate: histDate }
                :
                    { userId: this.props.user.user.id }

            let histInfo = histDate ?
                    { userId: this.props.user.user.id, userDate: histDate, user: this.state.historyUser, pageIndex: 1, pageSize: HIST_PAGE_SZE }
                :
                    { userId: this.props.user.user.id, user: this.state.historyUser, pageIndex: 1, pageSize: HIST_PAGE_SZE }

            fetchUserUsers.bind(this)(userInfo)
            fetchUserHistory.bind(this)(histInfo);

            chkReturn = setInterval(this.userEditVerify, 100);
        }
        else
            chkReturn = 0
    }

    newUserSearch(histUser) {
        if (chkReturn) return;
        chkReturn = 1;

        if (histUser != this.state.historyUser) {
            this.setState(
                {
                    historyPage: 1,
                    historyUser: histUser
                })

            let histInfo = this.state.historyDate ?
                    { userId: this.props.user.user.id, userDate: this.state.historyDate, user: histUser, pageIndex: 1, pageSize: HIST_PAGE_SZE }
                :
                    { userId: this.props.user.user.id, user: histUser, pageIndex: 1, pageSize: HIST_PAGE_SZE }

            fetchUserHistory.bind(this)(histInfo);

            chkReturn = setInterval(this.userEditVerify, 100);
        }
        else
            chkReturn = 0
    }

    loadMore(e) {
        if (chkReturn) return;
        chkReturn = 1;

        let histPage = this.state.historyPage
        let histDate = this.state.historyDate
        let histUser = this.state.historyUser

        if (this.props.user.history.userChangeHistoryRecords.length < this.props.user.history.totalRecords) {
            histPage++
            this.setState({ historyPage: histPage })
        }
        else {
            chkReturn = 0
            return
        }

        let histInfo = histDate ?
                { userId: this.props.user.user.id, userDate: histDate, user: histUser, pageIndex: histPage, pageSize: HIST_PAGE_SZE }
            :
                { userId: this.props.user.user.id, user: histUser, pageIndex: histPage, pageSize: HIST_PAGE_SZE }

        fetchUserHistory.bind(this)(histInfo);

        chkReturn = setInterval(this.userEditVerify, 100);
    }

    afterOpen() {
        $('div#Details').css('display', 'block')
        $('li[panel="Details"]').addClass('selected')

        if (this.state.viewUser) {
            $('select#status').attr('disabled', 'disabled')
            $('button.details').attr('disabled', 'disabled')

            $('.seo').attr('disabled', 'disabled')

            setTimeout(function () {
                $(document.getElementsByTagName('iframe')[0].contentDocument.getElementsByTagName('body')).css('background', '#ebebe4')
                $(document.getElementsByTagName('iframe')[0].contentDocument.getElementsByTagName('body')).attr('contenteditable', 'false')
            }, 500)
        }
    }
 
    fetchUserErrorClear() {
        this.props.dispatch(fetchUserError);
    }

    errorUserClear(e) {
        this.props.dispatch(errorUser);

        if (this.props.user.error === "409") {
            let id = e.target.attributes.user.value;

            fetchUser.bind(this)(id);
        }
    }

    errorNoDataClear() {
        this.props.dispatch(clearNoDataError);
    }

    changeState(e) {

        if (chkReturn) return;
        chkReturn = 1;

        userState = e.target.value

        $('select.userState').css('disabled', 'disabled')

        fetchUser.bind(this)(e.target.attributes.id.value);

        chkReturn = setInterval(this.changeStateVerify, 100);
    }
    changeStateVerify() {

        if (this.props.user.updated || this.props.user.error) {
            clearInterval(chkReturn);

            var user = Object.assign({}, this.props.user.user)

            user.isActive = userState == 'Active';

            updateUser.bind(this)(user.id, user)       
            chkReturn = setInterval(this.closeUser, 100);
        }
    }

    userView(e) {
        if (this.props.users.fetching) return

        this.setState({ viewUser: true })
        this.userEdit(e)
    }

    userEdit(e) {

        if (chkReturn) return;
        chkReturn = 1;

        let id = e.target.attributes.user ? e.target.attributes.user.value : e.currentTarget.attributes.user.value;

        this.setState({
            user: {
                details: {},
                detailsDirty: false,

                seo: {},
                seoDirty: false,

                role: {},
                roleDirty: false
            },
            currentPanel: 'Details'
        });

        fetchUser.bind(this)(id);
        fetchUserHistory.bind(this)({ userId: id, pageIndex: 1, pageSize: HIST_PAGE_SZE });
        fetchUserUsers.bind(this)({ userId: id })

        chkReturn = setInterval(this.userEditVerify, 100);
    }
    userEditVerify() {

        if (this.props.user.updated || this.props.user.error) {

            if (this.props.user.updated) {
                this.setState({
                    editUserMode: true
                });
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }
 
    updateUser(e) {
        $('button.modbrick').attr('disabled', 'disabled')

        let changes = this.state.user
        let user = Object.assign({}, this.props.user.user)

        for (const [key, value] of Object.entries(changes.details))
            user[key] = value

        for (const [key, value] of Object.entries(changes.seo))
            user[key] = value

        for (const [key, value] of Object.entries(changes.role)) {
            if (user.userRoles.filter(userrole => userrole.roleId == key).length) {
                user.userRoles.map(role => {
                    if (role.roleId == key) {
                        role.assigned = value
                        return role
                    }
                    else return role
                })
            }
            else {
                var newrole = {
                    userRoleId: 0,
                    roleId: parseInt(key),
                    userId: user.id,
                    assigned: value
                }

                user.userRoles.push(newrole)
            }
        }

        user.LastUpdatedby = this.props.users.user
        updateUser.bind(this)(user.id, user)       

        chkReturn = setInterval(this.closeUser, 100);
    }

    cancelUser() {
        this.props.dispatch(errorUser);

        this.setState({
            viewUser: false,
            editUserMode: false
        });

        this.props.dispatch(fetchUsersList);
    }
    closeUser() {
        if (this.props.user.updated || this.props.user.error) {
            $('button.modbrick').removeAttr('disabled')

            if (this.props.user.updated) {
                this.cancelUser();
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    processStatusFilter(filters) {
        if (this.props.users.fetching) return

        this.setState({ activeStatusFilters: filters })
     }

    pageDescriptionChange(editor) {
        editor.on('keyup', (e) => {
            this.pageDescriptionUpdate(e)
        })

        editor.on('change', (e) => {
            this.pageDescriptionUpdate(e)
        })
    }

    pageDescriptionUpdate(e) {
        let user = this.state.user
        let htmlData = e.target.innerHTML ? e.target.innerHTML : e.level.content

        user.seo.designerDescription = htmlData
        user.seoDirty = true

        this.setState({
            user: user
        })
    }

    detailsUpdate(e) {
        let user = this.state.user

        user.details[e.target.name] = e.target.name == 'isActive' ? e.target.value == 'Active' : e.target.value
        user.detailsDirty = true

        this.setState({
            user: user
        })
    }

    seoUpdate(e) {
        let user = this.state.user

        user.seo[e.target.name] = e.target.value
        user.seoDirty = true

        if (e.target.name == 'designerPagePublished')
            user.seo['designerPagePublished'] = e.target.checked

        if (e.target.name == 'designerLocationName')
            user.seo['designerLocationId'] = this.props.locations.filter((loc) => { return loc.name == e.target.value })[0].id

        this.setState({
            user: user
        })
    }

    roleUpdate(e) {
        let user = this.state.user

        user.role[e.target.attributes.role.value] = e.target.checked
        user.roleDirty = true

        this.setState({
            user: user
        })
    }

    confirmNo() {
        let user = this.state.user

        if (user.detailsDirty) {
            user.details = {}
            user.detailsDirty = false

            this.setState({
                user: user,
                confirm: false
            })
        }
        else if (user.seoDirty) {
            user.seo = {}
            user.seoDirty = false

            this.setState({
                user: user,
                confirm: false
            })
        }
        else if (user.roleDirty) {
            user.role = {}
            user.roleDirty = false

            this.setState({
                user: user,
                confirm: false
            })
        }

        this.switchPanel(this.state.newPanel)
    }

    confirmYes() {
        let user = this.state.user

        if (user.detailsDirty) {
            user.detailsDirty = false

            this.setState({
                user: user,
                confirm: false
            })
        }
        else if (user.seoDirty) {
            user.seoDirty = false

            this.setState({
                user: user,
                confirm: false
            })
        }
        else if (user.roleDirty) {
            user.roleDirty = false

            this.setState({
                user: user,
                confirm: false
            })
        }

        this.switchPanel(this.state.newPanel)
    }

    render() {
        return (
            <div className="users col-xs-12">
                <CommError error={this.props.user.error} onClose={this.errorUserClear} />
                <CommError error={this.props.users.error} onClose={this.fetchUserErrorClear} />

                <ConfirmModal open={this.props.users.noData} heading={"Users"} msg={"No Records"} notifyOnly={true} onYes={this.errorNoDataClear} />

                <div className="headWrapper">
                    <div>
                        <h1>Users</h1>
                    </div>
                </div>

                <div className="tableWrapper"> 
                    {
                        this.props.users.fetching ?
                            <Spinner name='line-spin-fade-loader' />
                        :
                            null
                    }
                    <row>
                        <div className="col-md-12">
                            <div className="col-md-10 searchbox pull-right">
                                <span>Search by User:</span>
                                {
                                    this.props.users.fetching ?
                                        <input id="search" disabled />
                                    :
                                        <input id="search" autocorrect="off" onChange={this.search} />
                                }
                            </div>
                        </div>
                    </row>

                    <row>
                        <div className="col-md-2">
                            <FilterList
                                multiselect
                                id={"Status"}
                                label={"Filter by Status"}
                                defSelections={["Active"]}
                                filters={this.props.users.filters}
                                processFilter={this.processStatusFilter}
                            />
                        </div>

                        <div className="col-md-10">
                            <table className="lists table table-striped">
                                <thead>
                                    <tr className="head">
                                        <th>User ID</th>
                                        <th>First Name</th>
                                        <th>Last Name</th>
                                        <th>Email</th>
                                        <th>Location</th>
                                        <th>Department</th>
                                        <th>Title</th>
                                        <th>Extension</th>
                                        <th>Status</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.props.usersList.filter((user) => {
                                            if (this.state.activeStatusFilters.includes('Active') && user.isActive)
                                                return true
                                            else if (this.state.activeStatusFilters.includes('Inactive') && !user.isActive)
                                                return true
                                            else
                                                return false
                                        })
                                        .filter((user) => {
                                            return this.state.search == '' ||
                                                user.firstName.toLowerCase().startsWith(this.state.search.toLowerCase()) ||
                                                user.lastName.toLowerCase().startsWith(this.state.search.toLowerCase())
                                        })
                                        .map((user) => {
                                            if (this.state.search == '') {
                                                user.firstMatch = false
                                                user.lastMatch = false

                                                return user
                                            }
                                            else if (user.firstName.toLowerCase().startsWith(this.state.search.toLowerCase())) {
                                                user.firstMatch = true
                                                user.firstPrefix = user.firstName.substr(0, this.state.search.length)
                                                user.firstSuffix = user.firstName.substr(this.state.search.length)

                                                return user
                                            }
                                            else {
                                                user.lastMatch = true
                                                user.lastPrefix = user.lastName.substr(0, this.state.search.length)
                                                user.lastSuffix = user.lastName.substr(this.state.search.length)

                                                return user
                                            }
                                        })
                                        .map((user, index) => {
                                            return <tr key={index}>
                                                <td>{user.id}</td>
                                                {
                                                    user.firstMatch ?
                                                        <td className="name" user={user.id} userdate={user.lastUpdatedAtDisplay} onClick={this.userView}><span>{user.firstPrefix}</span>{user.firstSuffix}</td>
                                                    :
                                                        <td className="name" user={user.id} userdate={user.lastUpdatedAtDisplay} onClick={this.userView}>{user.firstName}</td>
                                                }
                                                {
                                                    user.lastMatch ?
                                                        <td className="name" user={user.id} userdate={user.lastUpdatedAtDisplay} onClick={this.userView}><span>{user.lastPrefix}</span>{user.lastSuffix}</td>
                                                    :
                                                        <td className="name" user={user.id} userdate={user.lastUpdatedAtDisplay} onClick={this.userView}>{user.lastName}</td>
                                                }
                                                <td>{user.email}</td>
                                                <td>{user.location}</td>
                                                <td>{user.department}</td>
                                                <td>{user.title}</td>
                                                <td>{user.officeExt}</td>
                                                <td>
                                                    {
                                                        this.props.users.fetching ?
                                                            <select id={user.id} className="userState" value={user.isActive ? 'Active' : 'Inactive'} disabled>
                                                                <option>Active</option>
                                                                <option>Inactive</option>
                                                            </select>
                                                        :
                                                            <select id={user.id} className="userState" value={user.isActive ? 'Active' : 'Inactive'} onChange={this.changeState}>
                                                                <option>Active</option>
                                                                <option>Inactive</option>
                                                            </select>
                                                    }
                                                </td>
                                                <td>
                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>}>
                                                        <i className="fa fa-edit" user={user.id} onClick={this.userEdit}></i>
                                                    </OverlayTrigger>
                                                </td>
                                            </tr>
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </row>
                </div>

                <CreateEditUser
                    errUser={this.props.user}
                    errUserClear={this.errorUserClear}

                    curUser={this.props.user}
                    histPage={this.state.historyPage}

                    isOpen={this.state.editUserMode}
                    userCheck={this.userCheck}
                    viewOnly={this.state.viewUser}
                    selectPanel={this.selectPanel}
                    users={this.props.user.users}
                    newDateSearch={this.newDateSearch}
                    newUserSearch={this.newUserSearch}
                    loadMore={this.loadMore}

                    locations={this.props.locations}

                    onPageDescChange={this.pageDescriptionChange}

                    onDetailsUpdate={this.detailsUpdate}
                    onSeoUpdate={this.seoUpdate}
                    onRoleUpdate={this.roleUpdate}
 
                    confirm={this.state.confirm}
                    onConfirmNo={this.confirmNo}
                    onConfirmYes={this.confirmYes}

                    onAfterOpen={this.afterOpen}
                    onRequestClose={this.updateUser}
                    onRequestCancel={this.cancelUser}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    user: state.user,
    users: state.users
});

export default connect(mapStateToProps)(Users)